import CommonSearchInputs from "./CommonSearchInputs";

export default CommonSearchInputs;
